import { memo } from 'react';

import AIModelIconSVG from '@/assets/ai-model-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IAIModelIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={AIModelIconSVG} {...props} />;

export const AIModelIcon = memo(IAIModelIcon) as typeof IAIModelIcon;
